import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  applyMakeRequest: ["make_id", "make"],
  applyMakeSuccess: ["makedata"],
  applyMakeFailure: ["status"],
});

export const ApplyMakeTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  fetching: null,
  success: null,
  error: null,
  make_id: null,
  makedata: null,
  make: null,
  status: null,
});

export const ApplyMakeSelectors = {
  getData: (state: any) => state.applyMake.data,
  isFetching: (state: any) => state.applyMake.fetching,
  isSuccess: (state: any) => state.applyMake.success,
  hasError: (state: any) => state.applyMake.error,
};

export const request = (state: any, { make_id, make }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    make_id,
    make: make,
    makedata: null,
    status: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { makedata } = action;
    const updateData = {
    fetching: false,
    success: true,
    error: false,
    makedata: makedata,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any, action: any) => {
  const { status } = action;
    const updateData = {
    fetching: false,
    success: false,
    error: true,
    status: status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.APPLY_MAKE_REQUEST]: request,
  [Types.APPLY_MAKE_SUCCESS]: success,
  [Types.APPLY_MAKE_FAILURE]: failure,
});
